import React, { FC } from 'react';

export const AdminH1: FC = ({ children }) => {
  return <h1 className="text-2xl font-semibold text-gray-900">{children}</h1>;
};
